import React from 'react';
import { FiSettings, FiShield, FiDatabase, FiMail } from 'react-icons/fi';

const Settings = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-gray-900">Platform Settings</h2>
        <p className="text-gray-600 mt-2">Configure platform-wide settings and preferences</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-4">
            <FiSettings className="text-primary mr-3" size={24} />
            <h3 className="text-lg font-semibold">General Settings</h3>
          </div>
          <p className="text-gray-600">Configure general platform settings</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-4">
            <FiShield className="text-primary mr-3" size={24} />
            <h3 className="text-lg font-semibold">Security</h3>
          </div>
          <p className="text-gray-600">Manage security and authentication settings</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-4">
            <FiDatabase className="text-primary mr-3" size={24} />
            <h3 className="text-lg font-semibold">Data Management</h3>
          </div>
          <p className="text-gray-600">Configure data retention and backup policies</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-4">
            <FiMail className="text-primary mr-3" size={24} />
            <h3 className="text-lg font-semibold">Email Configuration</h3>
          </div>
          <p className="text-gray-600">Set up email templates and SMTP settings</p>
        </div>
      </div>
    </div>
  );
};

export default Settings;